const map = new Map();

const use = (key, defaultValue) => {
	if (!map.has(key)) {
		map.set(key, typeof defaultValue === "function" ? defaultValue() : defaultValue);
	}
	return map.get(key);
};

module.exports = {
	use
};